import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedBooks: [],
  freeBookredux: 0, 
};

const bookSlice = createSlice({
  name: "books",
  initialState,
  reducers: {
    toggleBookSelection: (state, action) => {
      if (Array.isArray(action.payload)) {
        state.selectedBooks = action.payload;
      }
    },
    saveSelectedBooks: (state, action) => {
      state.selectedBooks = action.payload || [];
    },
    resetSaveSelectedBooks: (state) => {
      state.selectedBooks = [];
    },

    setFreeBookredux: (state, action) => {
      state.freeBookredux = action.payload;
    },

    clearFreeBookredux: (state) => {
      state.freeBookredux = 0;
    },
  },
});

export const {
  toggleBookSelection,
  saveSelectedBooks,
  resetSaveSelectedBooks,
  setFreeBookredux,
  clearFreeBookredux,
} = bookSlice.actions;

export default bookSlice.reducer;
